import { render, staticRenderFns } from "./about_pc.vue?vue&type=template&id=41546790&scoped=true&"
import script from "./about_pc.vue?vue&type=script&lang=js&"
export * from "./about_pc.vue?vue&type=script&lang=js&"
import style0 from "./about_pc.vue?vue&type=style&index=0&id=41546790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41546790",
  null
  
)

export default component.exports